/**
 * /:ws/settings/workspace/members/:userId — the members page focused on one member's row (e.g. the invite flow's
 * "Suspended — reactivate instead" link). Renders nothing itself: the parent route reads the param and focuses the row.
 */
import { createFileRoute } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';

const MemberFocus = observer(function MemberFocus(): ReactNode {
  return null;
});

export const Route = createFileRoute('/$ws/settings/workspace/members/$userId')({
  staticData: { workingSet: true },
  component: MemberFocus,
});
